import React, { useState, useEffect } from "react";
import "../../admin_resources/css/admin_layout.css";
import "../../admin_resources/css/admin_common.css";
import "../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "./Admin_Header";
import axios from "axios";

const Admin_Permission = () => {
  const [adminList, setAdminList] = useState([]);
  const [filteredAdminList, setFilteredAdminList] = useState([]);
  const [selectedAdminId, setSelectedAdminId] = useState(null);
  const [, setPermissions] = useState({});
  const [updatedPermissions, setUpdatedPermissions] = useState({});
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
	const titleElement = document.getElementsByTagName("title")[0];
	titleElement.innerHTML = `아소비 관리자 페이지`;
	
    const fetchAdminList = async () => {
      try {
        const response = await axios.get("/permissions");
        const uniqueAdmins = [
          ...new Map(
            response.data.map((item) => [item.adminId, item])
          ).values(),
        ];

        // adminName을 기준으로 가나다순 정렬
        uniqueAdmins.sort((a, b) =>
          a.adminName.localeCompare(b.adminName, "ko-KR")
        );
        setAdminList(uniqueAdmins);
        setFilteredAdminList(uniqueAdmins); // 초기에는 모든 관리자 목록을 필터링
      } catch (error) {
        console.error("Error fetching admin list:", error);
      }
    };

    fetchAdminList();
  }, []);

  // 이름 검색 처리
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchName(query);

    if (query === "") {
      // 검색어가 비어 있으면 모든 관리자를 표시하고 권한 부여 초기화
      setFilteredAdminList(adminList);
      setSelectedAdminId(null); // 권한 부여 초기화
      setPermissions({});
      setUpdatedPermissions({});
    } else {
      // 검색어에 맞는 관리자 필터링
      const filteredAdmins = adminList.filter((admin) =>
        admin.adminName.includes(query)
      );
      setFilteredAdminList(filteredAdmins);
    }
  };

  const fetchPermissions = async (adminId) => {
    try {
      const response = await axios.get(`/permissions/${adminId}`);
      setPermissions(response.data);
      setUpdatedPermissions(response.data);
      setSelectedAdminId(adminId);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const handleCheckboxChange = (menu, value) => {
    setUpdatedPermissions((prev) => {
      const newPermissions = { ...prev, [menu]: value };

      // 상위 메뉴 체크 시 하위 메뉴 자동 체크 (value 값을 반영하여 설정)
      if (menu === "site") {
        newPermissions.banner = value;
        newPermissions.popup = value;
      } else if (menu === "board") {
        newPermissions.notice = value;
        newPermissions.event = value;
        newPermissions.social = value;
        newPermissions.magazine = value;
      } else if (menu === "form") {
        newPermissions.ent = value;
        newPermissions.fr = value;
        newPermissions.franchise = value;
        newPermissions.schedule = value;
        newPermissions.jisa = value;
        newPermissions.q = value;
        newPermissions.etc_q = value;
      }

      // 부모 카테고리 체크 로직 (상위 메뉴 해제)
      if (["banner", "popup"].includes(menu)) {
        newPermissions.site = newPermissions.banner || newPermissions.popup;
      } else if (["notice", "event", "social", "magazine"].includes(menu)) {
        newPermissions.board =
          newPermissions.notice ||
          newPermissions.event ||
          newPermissions.social ||
          newPermissions.magazine;
      } else if (
        ["ent", "fr", "franchise", "schedule", "jisa", "q", "etc_q"].includes(
          menu
        )
      ) {
        newPermissions.form =
          newPermissions.ent ||
          newPermissions.fr ||
          newPermissions.franchise ||
          newPermissions.schedule ||
          newPermissions.jisa ||
          newPermissions.q ||
          newPermissions.etc_q;
      }

      // 부모 카테고리 체크 로직 (상위 메뉴 해제 시 하위 메뉴도 해제)
      if (menu === "site" && !value) {
        // 상위 메뉴인 'site'가 해제되면 'banner'와 'popup'도 해제
        newPermissions.banner = false;
        newPermissions.popup = false;
      } else if (menu === "board" && !value) {
        // 상위 메뉴인 'board'가 해제되면 'notice', 'event', 'social', 'magazine'도 해제
        newPermissions.notice = false;
        newPermissions.event = false;
        newPermissions.social = false;
        newPermissions.magazine = false;
      } else if (menu === "form" && !value) {
        // 상위 메뉴인 'form'이 해제되면 'ent', 'fr', 'franchise', 'schedule', 'jisa', 'q', 'etc_q'도 해제
        newPermissions.ent = false;
        newPermissions.fr = false;
        newPermissions.franchise = false;
        newPermissions.schedule = false;
        newPermissions.jisa = false;
        newPermissions.q = false;
        newPermissions.etc_q = false;
      }

      return newPermissions;
    });
  };

  const savePermissions = async () => {
    try {
      await axios.post(`/update/${selectedAdminId}`, updatedPermissions);
      alert("권한이 성공적으로 저장되었습니다.");
    } catch (error) {
      console.error("Error updating permissions:", error);
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_info">
        <div className="path-sec">
          HOME &gt; <span className="menu1">정보수정</span> &gt;
          <span className="menu2"> 권한수정</span>
        </div>

        <table>
          <tr>
            {/* 왼쪽 사이드 메뉴 */}
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">정보수정</h3>
                <ul className="snb_list">
                  <li>
                    <a href="/admin/admin_info">정보수정</a>
                  </li>
                  <li className="cur">
                    <a href="/admin/admin_permission">권한수정</a>
                  </li>
                </ul>
              </div>
            </td>

            {/* 오른쪽: 관리자 목록 및 권한 수정 */}
            <td className="right_m" style={{ padding: "20px" }}>
              <div className="sec-cont">
                <div className="content-wrapper" style={{ display: "flex" }}>
                  {/* 관리자 목록 */}
                  <div
                    className="admin-list"
                    style={{ width: "20%", borderRight: "1px solid #ddd" }}
                  >
                    <div
                      className="search-bar"
                      style={{ marginBottom: "20px", textAlign: "center" }}
                    >
                      <input
                        type="text"
                        value={searchName}
                        onChange={handleSearch}
                        placeholder="이름으로 검색"
                        style={{
                          padding: "8px",
                          marginBottom: "10px",
                          width: "100%",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    {filteredAdminList.map((admin) => (
                      <div
                        key={admin.adminId}
                        className="admin-item"
                        style={{ padding: "10px", textAlign: "center" }}
                      >
                        <button
                          style={{
                            backgroundColor:
                              selectedAdminId === admin.adminId
                                ? "#004080"
                                : "#ccc",
                            color:
                              selectedAdminId === admin.adminId
                                ? "#fff"
                                : "#000",
                            width: "70%",
                            border: "none",
                            padding: "10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                          }}
                          onClick={() => fetchPermissions(admin.adminId)}
                        >
                          {admin.adminName} ({admin.adminId})
                        </button>
                      </div>
                    ))}
                  </div>

                  {/* 권한 수정 패널 */}
                  <div className="permissions-panel">
                    <h3>
                      권한 부여 {selectedAdminId && `(${selectedAdminId})`}
                    </h3>
                    {selectedAdminId ? (
                      <div className="permission-content">
                        <label>
                          <input
                            type="checkbox"
                            checked={updatedPermissions.site || false}
                            onChange={(e) =>
                              handleCheckboxChange("site", e.target.checked)
                            }
                          />
                          사이트 관리
                        </label>
                        <div className="permission-sub">
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.banner || false}
                              onChange={(e) =>
                                handleCheckboxChange("banner", e.target.checked)
                              }
                            />
                            메인배너 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.popup || false}
                              onChange={(e) =>
                                handleCheckboxChange("popup", e.target.checked)
                              }
                            />
                            팝업배너 관리
                          </label>
                        </div>

                        <label>
                          <input
                            type="checkbox"
                            checked={updatedPermissions.board || false}
                            onChange={(e) =>
                              handleCheckboxChange("board", e.target.checked)
                            }
                          />
                          게시판 관리
                        </label>
                        <div className="permission-sub">
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.notice || false}
                              onChange={(e) =>
                                handleCheckboxChange("notice", e.target.checked)
                              }
                            />
                            아소비소식 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.event || false}
                              onChange={(e) =>
                                handleCheckboxChange("event", e.target.checked)
                              }
                            />
                            아소비이벤트 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.social || false}
                              onChange={(e) =>
                                handleCheckboxChange("social", e.target.checked)
                              }
                            />
                            아소비소셜 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.magazine || false}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  "magazine",
                                  e.target.checked
                                )
                              }
                            />
                            아소비꿀지 관리
                          </label>
                        </div>

                        <label>
                          <input
                            type="checkbox"
                            checked={updatedPermissions.form || false}
                            onChange={(e) =>
                              handleCheckboxChange("form", e.target.checked)
                            }
                          />
                          데이터 관리
                        </label>

                        <div className="permission-sub">
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.ent || false}
                              onChange={(e) =>
                                handleCheckboxChange("ent", e.target.checked)
                              }
                            />
                            입회신청 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.fr || false}
                              onChange={(e) =>
                                handleCheckboxChange("fr", e.target.checked)
                              }
                            />
                            창업신청 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.franchise || false}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  "franchise",
                                  e.target.checked
                                )
                              }
                            />
                            가맹점 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.schedule || false}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  "schedule",
                                  e.target.checked
                                )
                              }
                            />
                            창업일정 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.jisa || false}
                              onChange={(e) =>
                                handleCheckboxChange("jisa", e.target.checked)
                              }
                            />
                            지사장 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.q || false}
                              onChange={(e) =>
                                handleCheckboxChange("q", e.target.checked)
                              }
                            />
                            앱 문의 관리
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              checked={updatedPermissions.etc_q || false}
                              onChange={(e) =>
                                handleCheckboxChange("etc_q", e.target.checked)
                              }
                            />
                            기타문의 관리
                          </label>
                        </div>

                        <div style={{ marginTop: "20px" }}>
                          <button
                            style={{
                              backgroundColor: "#0066cc",
                              color: "white",
                              padding: "10px 20px",
                              border: "none",
                              cursor: "pointer",
                              float: "right",
                            }}
                            onClick={savePermissions}
                          >
                            적용
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p>관리자를 선택해주세요.</p>
                    )}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Permission;
